import { CSSProperties, HtmlHTMLAttributes, LegacyRef, memo, ReactNode } from "react";
import classnames from "classnames";

import styles from "./style.module.scss";

export type FormBlockProps = {
  header?: ReactNode;
  headerClassName?: string;
  contentClassName?: string;
  contentStyle?: CSSProperties | undefined;
  contentRef?: LegacyRef<HTMLDivElement>
} & HtmlHTMLAttributes<HTMLDivElement>

export const FormBlock = memo<FormBlockProps>((
  {
    children,
    header,
    headerClassName,
    contentClassName,
    className,
    contentRef,
    contentStyle,
    ...props
  }) => {

  return (
    <div data-style="formBlock" className={classnames(styles.root, className)} {...props}>
      {
        header &&
        <div className={classnames(styles.header, headerClassName)}>
          {header}
        </div>
      }
      <div className={classnames(styles.content, contentClassName)} ref={contentRef} style={contentStyle}>
        {children}
      </div>
    </div>
  );
});

export default FormBlock;
